import React, { useState, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

//Components
import { Timezone } from '../../../../../../components/uiControls'
import { Pill, Button } from '@gpstrackit/gtc-react-controls';
import Modal, { ModalBody, ModalFooter } from "Components/Modal";
import TableView from 'Components/TableView';
import { Grid } from '@mui/material';

//Actions
import { closeWarningDetailsModal, searchMaintenanceWarningEvents, resetDetails } from './redux/slice';
import DOMPurify from "dompurify";

const WarningDetails = (props) => {
    const { timezone } = props
    const dispatch = useDispatch(0)
    const { messages, locale } = useIntl();
    const tableRef = useRef();

    const types = [
        { id: "definition", label: messages['warnings_main_definition'], color: '#66bb6a', },
        { id: "details", label: messages['warnings_main_details'], color: '#f1f1f1', }
    ];

    //Redux States
    const { open, loading, data, items, total, limit, offset } = useSelector(state => state.warningsDetailsRedux);
    const loadingUserLanguage = useSelector(state => state.commomRedux.loadingUserLanguage);
    const dateformat = useSelector(state => state.securityRedux.user.dateformat);

    //Local States
    const [type, setType] = useState("definition");
    const [page, setPage] = useState(0);

    const handleClose = () => {
        dispatch(closeWarningDetailsModal())
    }

    const tabsHandler = (value) => {
        dispatch(resetDetails({ items: [], total: 0, offset: 0 }))
        setType(value)
        setPage(0)
    }

    const generateSummary = () => {
        let description = null
        try {
            let labels = localStorage.getItem("langByS3")
            labels = labels.replace('export default ', '');
            labels = JSON.parse(JSON.parse(labels));
            for (const key in labels) {
                let warning = key.toUpperCase()
                if (warning.includes(data?.warning.toUpperCase())) {
                    description = labels[key]
                }
            }
        } catch (exc) {

        }
        if (description) {
            return (
                <div className="container-warning-summary">
                    <h2 style={{ marginTop: 10 }}>{messages[`warnings_main_${data?.warning}`] || data?.warning}</h2>
                    <div
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }} 
                    />
                </div>
            )
        } else {
            return (
                <div className="container-warning-summary">
                    <h2 style={{ marginTop: 10 }}>{messages[`warnings_main_${data?.warning}`] || data?.warning}</h2>
                    <div>
                        <p>{messages['warnings_main_description_comming_soon']}</p>
                    </div>
                </div>
            )
        }
    }

    const onChangePage = (paramPage) => {
        setPage(paramPage);
        try {
            let currentOffset = paramPage === 1 ? 0 : offset + limit
            dispatch(resetDetails({ offset: currentOffset }))
            dispatch(searchMaintenanceWarningEvents({ ...data, offset: currentOffset }))
        } catch (exc) { }
    }

    const summary = generateSummary();

    return (
        <Modal
            title={`${messages[`warnings_main_${data?.warning}`] || data?.warning}`}
            position="right"
            size="small"
            open={open}
            loading={loading || loadingUserLanguage}
            handleClose={() => handleClose()}
        >
            <ModalBody>
                <div style={{ overflow: 'hidden', padding: '10px 25px' }}>
                    <Grid container spacing={1} style={{ marginTop: 5 }}>
                        {types.map((filter, index) => {
                            return (
                                <Grid item xs={6} key={index} className="maintenance-warnings-pills">
                                    <Pill
                                        key={index}
                                        textField={'label'}
                                        item={{ ...filter, color: type === filter.id ? "#66bb6a" : "#f1f1f1" }}
                                        onClick={() => tabsHandler(filter.id)}
                                        style={{ border: '0', width: '100%', textAlign: 'center' }}
                                        label="pill-label-text"
                                        size="filled"
                                    />
                                </Grid>
                            )
                        })}
                    </Grid>
                    <Grid container spacing={1} style={{ marginTop: 5 }}>
                        {
                            type === "definition" &&
                            <Grid item xs={12}>
                                {
                                    summary
                                }
                            </Grid>
                        }
                        {
                            type === "details" &&
                            <Grid item xs={12}>
                                <TableView
                                    ref={tableRef}
                                    data={items || []}
                                    loading={loading}
                                    page={page}
                                    rowsPerPage={25}
                                    name="maintenance-warnings-details"
                                    topSpaceSize={315}
                                    infiniteScroll={true}
                                    viewType="list"
                                    messages={messages}
                                    itemSelector={false}
                                    serverSide
                                    onChangePage={(newPage) => onChangePage(newPage)}
                                    total={total}
                                    moreRowsAvailable={items?.length < total}
                                    renderRow={(item) => {
                                        return (
                                            <div className="maintenance-warnings-details-card">
                                                <div>
                                                    <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['warnings_main_warning_time']}:</label><span><Timezone
                                                        date={new Date(item?.unitTime)}
                                                        dateFormat={dateformat}
                                                        timeFormat="hh:mm a"
                                                        timezone={timezone || "UTC"}
                                                        className="maintenance-warnings-date"
                                                        customFormat={true}
                                                        locale={locale}
                                                        noWrap={false}
                                                        oneControl={true}
                                                    /></span>
                                                </div>
                                                <div>
                                                    <label style={{ fontWeight: 700, marginRight: 5 }}>{messages['warnings_main_value']}:</label><span>{item.value}</span>
                                                </div>
                                            </div>
                                        )
                                    }}
                                />
                            </Grid>
                        }

                    </Grid>
                </div>
            </ModalBody>
            <ModalFooter>
                <div style={{ marginLeft: 5 }}>
                    <Button variant='primary' onClick={() => handleClose()}>
                        {messages['warnings_main_close']}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default WarningDetails;